/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type NumberType = 1 | 2 | 3;

export const NumberType = {
    NUMBER_1: 1 as NumberType,
    NUMBER_2: 2 as NumberType,
    NUMBER_3: 3 as NumberType
};